import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useCombinedAnalytics } from '../../hooks/useCombinedAnalytics';
import TimeRangeSelector from './TimeRangeSelector';
import OverviewStatsCards from './OverviewStatsCards';
import TrafficChart from './TrafficChart';
import TunnelsTable from './TunnelsTable';
import TopIPsTable from './TopIPsTable';

const CombinedAnalyticsTab = () => {
  const { token } = useAuth();
  const [timeRange, setTimeRange] = React.useState('7days');

  const {
    loading,
    stats,
    clientStats,
    connections,
    ipStats
  } = useCombinedAnalytics(token, timeRange);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <TimeRangeSelector timeRange={timeRange} setTimeRange={setTimeRange} />

      <OverviewStatsCards stats={stats} clientStats={clientStats} />

      <div className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-xl p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">График трафика</h3>
        <TrafficChart 
          connections={connections} 
          timeRange={timeRange} 
          clientStatsActive={clientStats.active} 
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Туннели</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-gray-200 dark:border-dark-800">
                <tr>
                  <th className="text-left py-2 px-3 text-gray-600 dark:text-dark-400 font-medium">Имя</th>
                  <th className="text-left py-2 px-3 text-gray-600 dark:text-dark-400 font-medium">Статус</th>
                  <th className="text-right py-2 px-3 text-gray-600 dark:text-dark-400 font-medium">Трафик</th>
                </tr>
              </thead>
              <tbody>
                <TunnelsTable tunnels={stats?.tunnel_details} />
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Топ IP-адресов</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-gray-200 dark:border-dark-800">
                <tr>
                  <th className="text-left py-2 px-3 text-gray-600 dark:text-dark-400 font-medium">IP</th>
                  <th className="text-center py-2 px-3 text-gray-600 dark:text-dark-400 font-medium">Конн.</th>
                  <th className="text-right py-2 px-3 text-gray-600 dark:text-dark-400 font-medium">Трафик</th>
                </tr>
              </thead>
              <tbody>
                <TopIPsTable ipStats={ipStats} />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CombinedAnalyticsTab;
